module.exports = __webpack_public_path__ + "img/Postmodernisme_Espen-Haavardsholm.1403e4c3.jpg";